module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-08.97ce31c8.svg";